<div class="notifications-list-container">
  <!-- Header with unread count and actions -->
  <div class="notifications-header" *ngIf="showHeader">
    <div class="header-info">
      <h3 class="header-title">Notifications</h3>
      <div class="unread-count" *ngIf="unreadCount$ | async as unreadCount">
        <span class="count-badge" [class.hidden]="unreadCount === 0">{{unreadCount}}</span>
      </div>
    </div>
    
    <div class="header-actions">
      <button mat-button 
              class="mark-all-read-button"
              *ngIf="showMarkAllAsRead && (unreadCount$ | async)! > 0"
              (click)="onMarkAllAsRead()"
              [disabled]="isMarkingAllAsRead"
              data-testid="mark-all-read-button">
        <mat-icon>done_all</mat-icon>
        <span class="button-text">Mark all read</span>
      </button>
    </div>
  </div>


  <!-- Loading state -->
  <div class="loading-container" *ngIf="loading$ | async">
    <div class="loading-spinner">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    <p class="loading-text">Loading notifications...</p>
  </div>

  <!-- Error state -->
  <div class="error-container" *ngIf="error$ | async as error">
    <div class="error-icon">
      <mat-icon>error_outline</mat-icon>
    </div>
  </div>

  <!-- Notifications list -->
  <div class="notifications-content" 
       *ngIf="!(loading$ | async) && !(error$ | async)">
    
    <!-- Empty state -->
    <div class="empty-state" 
         *ngIf="(notifications$ | async)?.length === 0">
      <div class="empty-icon">
        <mat-icon>notifications_none</mat-icon>
      </div>
      <h4 class="empty-title">No notifications</h4>
      <p class="empty-message">
        You're all caught up! New notifications will appear here.
      </p>
    </div>

    <!-- Notifications list -->
    <div class="notifications-list" 
         *ngIf="(notifications$ | async)?.length">
      <app-notification-tile
        *ngFor="let notification of notifications$ | async; trackBy: trackByNotificationId"
        [notification]="notification"
        [enableVisibilityTracking]="true"
        (click)="onNotificationClick(notification)"
        (delete)="onDelete(notification.id)"
        (visibilityChanged)="onNotificationVisibilityChanged($event)"
        class="notification-item"
        [attr.data-testid]="'notification-' + notification.id">
      </app-notification-tile>
    </div>
  </div>
</div>